import React, { Component } from 'react'
import { connect } from 'react-redux'

// actions
import { openOverlay } from '../../../../../actions/common'
import { triggerPopup } from '../../../../../actions/backdrop'

// components
import Modal from '../../../../../shared/components/Modal'
import CarRentalContractOverlay from '../../../../../shared/overlays/CarRentalContractOverlay'

// elements
import Button from '../../../../../shared/elements/button'
import { ModalIcons } from '../../../../../shared/elements/icons'

// utils
import { translation } from '../../../../../utils/helpers'

class CarRentalContract extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedCarRentalId: null
    }

    this.openOverlay = this.openOverlay.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.openPopup = this.openPopup.bind(this)
    this.getCars = this.getCars.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  openOverlay (e) {
    e.persist()
    if (e.target !== null && e.target.id.indexOf('_') !== -1) {
      let carRentalId = parseInt(e.target.id.split('_')[1])
      this.setState({ selectedCarRentalId: carRentalId }, () => {
        // console.log('Open (multi) with orderId', this.props.order.Id, ' selectedCarRentalId', this.state.selectedCarRentalId)
        this.props.openOverlay('CarRentalContractOverlay')
      })
    } else {
      // console.log('Open with orderId', this.props.order.Id, ' selectedCarRentalId', this.state.selectedCarRentalId)
      this.props.openOverlay('CarRentalContractOverlay')
    }
    // e.preventDefault()
    this.setState({
      carrentalselectionmodal: false
    })
    this.props.triggerPopup(false)
  }

  openPopup (modal) {
    this.setState({
      [modal]: true
    })
    this.props.triggerPopup(true)
  }

  onClose () {
    this.setState({
      selectedCarRentalId: null
    })
    this.props.onUpdateOrder
  }

  handleClick (e) {
    let cars = this.getCars()
    if (cars.length > 1) {
      this.openPopup('carrentalselectionmodal')
    } else {
      this.setState({ selectedCarRentalId: cars[0].CarRentalId }, () => {
        this.openOverlay(e)
      })
    }
  }

  getCars () {
    let cars = {}
    if (this.props.order !== undefined) {
      if (Array.isArray(this.props.order.CarRentalAssignments)) {
        let assignments = this.props.order.CarRentalAssignments
        for (let i = 0; i < assignments.length; i++) {
          if (assignments[i].CarRentalId === null) continue
          if (cars[assignments[i].CarRentalId] === undefined) {
            cars[assignments[i].CarRentalId] = {
              CarRentalId: assignments[i].CarRentalId,
              CarNumber: assignments[i].CarNumber,
              Identity: assignments[i].Identity
            }
          }
        }
      }
    }
    let carsArray = Object.keys(cars).map(x => cars[x])
    // if (this.props.order.CarRentalId > 0 && carsArray.findIndex(x => x.CarRentalId !== this.props.order.CarRentalId) === -1) {
    //   carsArray.push({ CarRentalId: this.props.order.CarRentalId, CarNumber: this.props.order.CarRentalNumber, Identity: this.props.order.CarRentalRegNumber })
    // }
    return carsArray
  }

  render () {
    let disabled = !this.props.order.CurrentShopCanAssignRentalCar
    let carsArray = this.getCars()
    const renderCar = (car, i) => {
      let carText = car.CarNumber + '. ' + car.Identity
      return (
        <Button key={'car_' + i} style='secondary' id={'car_' + car.CarRentalId} labelText={carText} onClick={this.openOverlay} />
      )
    }

    const closeCarRentalSelectionModal = () => {
      this.props.triggerPopup(false)
      this.setState({
        carrentalselectionmodal: false
      })
    }
    return (
      <div>
        <Button noSubmit name='CarRentalContract' style='secondary' labelText={translation(16781)} onClick={this.handleClick} disabled={disabled} />
        {this.state.carrentalselectionmodal && <div className='carrentalselection_modal'>
          <Modal
            show={this.state.carrentalselectionmodal}
            onClose={closeCarRentalSelectionModal}
            header={translation(16781)}
            icon={ModalIcons.CarRental}>
            <div>
              {carsArray.map(renderCar)}
            </div>
          </Modal>
        </div>}
        {this.state.selectedCarRentalId && this.props.order && <CarRentalContractOverlay order={this.props.order} carRentalId={this.state.selectedCarRentalId} onClose={this.onClose} />}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { openOverlay, triggerPopup })(CarRentalContract)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/CarRentalContract/index.js